/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Ads API
 * API for managing board configurations, settings, and metadata
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Get ads
 */
export const getAdsQueryLimitMax = 1000;

export const GetAdsQueryParams = zod
    .object({
        ad_type: zod
            .enum([
                "PLACE_HOLDER",
                "PRODUCT_LINKER",
                "PRODUCT_LINKER_OGP",
                "PRODUCT_CARD",
                "TOP_BANNER",
                "SECTION_BANNER",
                "USERS_BANNER",
                "USERS_BANNER_RECTANGLE",
                "AUTH_BANNER",
            ])
            .optional(),
        product_id: zod.number().optional(),
        limit: zod.number().min(1).max(getAdsQueryLimitMax).optional(),
    })
    .strict();

export const getAds200ResponseDataItemImagePathMax = 150;

export const getAds200ResponseDataItemAdTitleMax = 40;

export const getAds200ResponseDataItemAdBodyMax = 130;

export const getAds200ResponseDataItemLinkUrlMax = 500;

export const GetAds200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .array(
                zod
                    .object({
                        ad_id: zod.number().optional(),
                        ad_type: zod
                            .enum([
                                "PLACE_HOLDER",
                                "PRODUCT_LINKER",
                                "PRODUCT_LINKER_OGP",
                                "PRODUCT_CARD",
                                "TOP_BANNER",
                                "SECTION_BANNER",
                                "USERS_BANNER",
                                "USERS_BANNER_RECTANGLE",
                                "AUTH_BANNER",
                            ])
                            .optional(),
                        image_path: zod.string().max(getAds200ResponseDataItemImagePathMax).optional(),
                        ad_title: zod.string().max(getAds200ResponseDataItemAdTitleMax).optional(),
                        ad_body: zod.string().max(getAds200ResponseDataItemAdBodyMax).optional(),
                        link_url: zod
                            .string()
                            .max(getAds200ResponseDataItemLinkUrlMax)
                            .optional()
                            .describe(
                                'URL, or \"\" when unset (per project convention for absent string data — see CLAUDE.md).',
                            ),
                        is_internal_modal_link: zod
                            .boolean()
                            .optional()
                            .describe(
                                "True when link_url points at an internal post whose board is modal_usage=MODAL — the ad should open that board's in-page modal instead of a new tab (see AdService::resolveInternalModalLink()).",
                            ),
                        modal_board_id: zod
                            .string()
                            .nullish()
                            .describe("board_id to open in-modal when is_internal_modal_link is true, otherwise null."),
                        modal_post_id: zod
                            .number()
                            .nullish()
                            .describe("post_id to open in-modal when is_internal_modal_link is true, otherwise null."),
                        ad_product_id: zod.number().nullish(),
                        display_rate_percent: zod.number().nullish(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict(),
            )
            .optional(),
        pagination: zod
            .object({
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                current_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetAds400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

export const GetAds500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.union([zod.literal(400), zod.literal(500)]).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create ad (admin/editor only)
 */
export const createItemBodyAdTitleMax = 40;

export const createItemBodyAdBodyMax = 130;

export const createItemBodyLinkUrlMax = 500;

export const CreateItemBody = zod
    .object({
        ad_type: zod.enum([
            "PLACE_HOLDER",
            "PRODUCT_LINKER",
            "PRODUCT_LINKER_OGP",
            "PRODUCT_CARD",
            "TOP_BANNER",
            "SECTION_BANNER",
            "USERS_BANNER",
            "USERS_BANNER_RECTANGLE",
            "AUTH_BANNER",
        ]),
        ad_title: zod.string().max(createItemBodyAdTitleMax).optional(),
        ad_body: zod.string().max(createItemBodyAdBodyMax).optional(),
        link_url: zod.string().max(createItemBodyLinkUrlMax).optional(),
        ad_product_id: zod.number().nullish(),
        display_rate_percent: zod.number().nullish(),
    })
    .strict();

export const createItem201ResponseDataItemImagePathMax = 150;

export const createItem201ResponseDataItemAdTitleMax = 40;

export const createItem201ResponseDataItemAdBodyMax = 130;

export const createItem201ResponseDataItemLinkUrlMax = 500;

export const CreateItem201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        ad_id: zod.number().optional(),
                        ad_type: zod
                            .enum([
                                "PLACE_HOLDER",
                                "PRODUCT_LINKER",
                                "PRODUCT_LINKER_OGP",
                                "PRODUCT_CARD",
                                "TOP_BANNER",
                                "SECTION_BANNER",
                                "USERS_BANNER",
                                "USERS_BANNER_RECTANGLE",
                                "AUTH_BANNER",
                            ])
                            .optional(),
                        image_path: zod.string().max(createItem201ResponseDataItemImagePathMax).optional(),
                        ad_title: zod.string().max(createItem201ResponseDataItemAdTitleMax).optional(),
                        ad_body: zod.string().max(createItem201ResponseDataItemAdBodyMax).optional(),
                        link_url: zod
                            .string()
                            .max(createItem201ResponseDataItemLinkUrlMax)
                            .optional()
                            .describe(
                                'URL, or \"\" when unset (per project convention for absent string data — see CLAUDE.md).',
                            ),
                        is_internal_modal_link: zod
                            .boolean()
                            .optional()
                            .describe(
                                "True when link_url points at an internal post whose board is modal_usage=MODAL — the ad should open that board's in-page modal instead of a new tab (see AdService::resolveInternalModalLink()).",
                            ),
                        modal_board_id: zod
                            .string()
                            .nullish()
                            .describe("board_id to open in-modal when is_internal_modal_link is true, otherwise null."),
                        modal_post_id: zod
                            .number()
                            .nullish()
                            .describe("post_id to open in-modal when is_internal_modal_link is true, otherwise null."),
                        ad_product_id: zod.number().nullish(),
                        display_rate_percent: zod.number().nullish(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const CreateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const CreateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const CreateItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * @summary Delete ad (admin/editor only)
 */
export const DeleteItemParams = zod
    .object({
        ad_id: zod.number(),
    })
    .strict();

export const DeleteItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const DeleteItem401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const DeleteItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const DeleteItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const DeleteItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * @summary Upload ad banner image (admin/editor only)
 */
export const UploadImageParams = zod
    .object({
        ad_id: zod.number(),
    })
    .strict();

export const UploadImageBody = zod
    .object({
        ad_image: zod.instanceof(File),
    })
    .strict();

export const UploadImage200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                image_url: zod.string().optional(),
                filename: zod.string().nullish(),
                message: zod.string().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UploadImage401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UploadImage403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UploadImage404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UploadImage422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UploadImage500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();
